import { render, staticRenderFns } from "./Receivers.vue?vue&type=template&id=4f18911d&scoped=true"
import script from "./Receivers.vue?vue&type=script&lang=js"
export * from "./Receivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f18911d",
  null
  
)

export default component.exports